import React from 'react'
import { withPrefix } from 'gatsby-link'

const ExperienceBox = props =>
  <section className='experience box'>
    <div className='logo-container' style={{background: props.color}}>
      <img src={`${__PATH_PREFIX__}/logos/${props.logo}`} />
      <h4>{props.role}</h4>
    </div>
    <div className='text-container'>
      <p>{props.shortDescription}</p>
      <ul>{props.tags.map(tag => <li key={tag}>{tag}</li>)}</ul>
    </div>
  </section>

export default ExperienceBox



// WEBPACK FOOTER //
// ./src/components/experience-box.js